import "./style.css";
import InfoModal from "../../../components/modal/InfoModal";
import Disclaimer from "../../../components/disclaimer";
import { useTranslation } from "react-i18next";

const DisclaimerModal = ({
    show,
    onClose,
}) => {
    const { t } = useTranslation();
    return (
        <InfoModal
            show={show}
            onClose={onClose}
            title={t("componentDisclaimer.title")}
        >
            <div className="tw:flex-1 tw:p-4 tw:p-0 tw:max-h-[70vh] scrollbar-always-visible tw:!pe-2 tw:md:!pe-0">
                <Disclaimer
                    textClassName={'tw:!text-[14px] tw:!text-[#4E4E4E] tw:!text-[400]'}
                    p4ClassName={'tw:!mb-0'}
                />
            </div>
        </InfoModal>

    )
}

export default DisclaimerModal